/**
 * Platform Stripe publishable key — extracted so Jest (CommonJS) can mock it
 * without choking on `import.meta`. Vite resolves the env at build time.
 *
 * Used by the player's PAYMENT_METHOD source (canMakePayment probe, F1d/WEB-183):
 * the probe only checks DEVICE capability (does the browser support Apple/Google
 * Pay), so the platform publishable key is sufficient — it does NOT need to be
 * the per-project Connect key used for the actual checkout charge.
 *
 * ⚠ NOTE: Stripe in this app is per-project Connect (each project enters its own
 * pk in StripeConnectForm). This is a separate PLATFORM key for the capability
 * probe only. When VITE_STRIPE_PUBLISHABLE_KEY is unset the probe returns []
 * (graceful — PAYMENT_METHOD conditions evaluate false), so set it in the build
 * env to activate device-capability targeting.
 *
 * IMPORTANT: use the literal `import.meta.env.VITE_*` shape — Vite's static
 * replacement only matches that exact AST. In Jest this module is intercepted
 * via moduleNameMapper, so the real `import.meta` access never runs in tests.
 */
export const STRIPE_PUBLISHABLE_KEY: string | undefined =
  import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || undefined;
